import { render, staticRenderFns } from "./apply-detail.vue?vue&type=template&id=fc4a35dc&scoped=true"
import script from "./apply-detail.vue?vue&type=script&lang=js"
export * from "./apply-detail.vue?vue&type=script&lang=js"
import style0 from "./apply-detail.vue?vue&type=style&index=0&id=fc4a35dc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4a35dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc4a35dc')) {
      api.createRecord('fc4a35dc', component.options)
    } else {
      api.reload('fc4a35dc', component.options)
    }
    module.hot.accept("./apply-detail.vue?vue&type=template&id=fc4a35dc&scoped=true", function () {
      api.rerender('fc4a35dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/quotation-apply/apply-detail.vue"
export default component.exports